import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames/bind';

import styles from './Surface.module.scss';

const cx = classNames.bind(styles);

interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  tag?: 'div';
  isRaised?: boolean;
  isLessonPlayer?: boolean;
}

// This component only has one usage
const Surface: FC<SurfaceProps> = ({
  children,
  className,
  isLessonPlayer,
  isRaised,
  tag: Tag = 'div',
  ...props
}) => {
  const classes = cx(
    'surface',
    {
      'surface--raised': isRaised,
      'surface--lesson-player': isLessonPlayer,
    },
    className
  );

  return (
    <Tag className={classes} {...props}>
      {children}
    </Tag>
  );
};

export default Surface;
